export interface CuratorialGroupState {
    group: any;
    allGroups: any;
    loading: boolean;
    message: string;
}

export enum CuratorialGroupActionType {
    START_REQUEST = "START_REQUEST",
    ALL_GROUPS_LOADED = "ALL_GROUPS_LOADED",
    GROUP_LOADED = "GROUP_LOADED",
    FINISH_REQUEST = "FINISH_REQUEST",
}
